import React, { useState } from 'react';
import { connect } from 'react-redux';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { isEmptyList, isNotEmptyList, isNotEmptyObject } from 'components/Common/Utils/StringUtils';
import { useEffect } from 'react';
import * as actions from 'components/TrustCenter/store/actions';
import {
    AUTO_COMPLETE_FIELD_THEME,
    FILLED_INPUT_AUTO_COMPLETE_FIELD_THEME
} from 'components/TrustCenter/TrustCenterMuiTheme';
import * as Constants from 'constants/Constants';

const IdentifierSearch = (props) => {
    const {
        identifiers,
        index,
        sendSelectedIdentifiers,
        variant,
        userAddedShipmentIdentifiers,
        selectedDatasource,
        getShipmentIdentifiers,
        modal,
        groupName,
        allSelected
    } = props;

    const [selectedIdentifier, setSelectedIdentifier] = useState([]);

    const [prevDatasource, setPrevDatasource] = useState(-1);

    const [touched, setTouched] = useState(false);

    const errorFieldObject = {
        isInvalid: false,
        message: ''
    };

    const [errorField, setErrorField] = useState({ ...errorFieldObject });

    const handleOnChangeIdentifier = (event, values, index) => {
        setSelectedIdentifier(values);
        const errorField = validateIdentifiers(values);
        sendSelectedIdentifiers(values, errorField, index);
        setErrorField({ ...errorField });
    };

    useEffect(() => {
        if (userAddedShipmentIdentifiers === undefined) {
            setSelectedIdentifier([]);
        } else {
            setSelectedIdentifier([...userAddedShipmentIdentifiers]);
        }
        setErrorField({ ...errorFieldObject });
    }, [userAddedShipmentIdentifiers]);

    useEffect(() => {
        if (isNotEmptyObject(selectedDatasource)) {
            if (!identifiers.has(selectedDatasource.id)) {
                getShipmentIdentifiers(selectedDatasource.id);
            }

            if (isNotEmptyList(userAddedShipmentIdentifiers)) {
                if (prevDatasource !== -1 && prevDatasource !== selectedDatasource.id) {
                    setSelectedIdentifier([]);
                    sendSelectedIdentifiers([], errorFieldObject, index);
                    setErrorField({ ...errorFieldObject });
                }
            } else {
                if (prevDatasource !== selectedDatasource.id) {
                    setSelectedIdentifier([]);
                    sendSelectedIdentifiers([], errorFieldObject, index);
                    setErrorField({ ...errorFieldObject });
                }
            }
            setPrevDatasource(selectedDatasource.id);
        } else {
            setSelectedIdentifier([]);
            sendSelectedIdentifiers([], errorFieldObject, index);
            setErrorField({ ...errorFieldObject });
        }
    }, [selectedDatasource, index]);

    const isError = (selectedIdentifier) => {
        setTouched(true);
        const tempErrorField = validateIdentifiers(selectedIdentifier);
        setErrorField({ ...tempErrorField });
    };

    const validateIdentifiers = (selectedIdentifier) => {
        let tempErrorField = { ...errorField };
        if (
            isNotEmptyList(identifiers.get(selectedDatasource?.id)) &&
            isEmptyList(selectedIdentifier)
        ) {
            tempErrorField.isInvalid = true;
            tempErrorField.message = 'Select an Identifier';
        } else {
            tempErrorField = { ...errorFieldObject };
        }
        return tempErrorField;
    };

    const disableField = () => {
        if (prevDatasource === -1) {
            return isEmptyList(userAddedShipmentIdentifiers);
        }

        return isEmptyList(identifiers.get(selectedDatasource?.id));
    };

    return (
        <div>
            <MuiThemeProvider
                theme={modal ? FILLED_INPUT_AUTO_COMPLETE_FIELD_THEME : AUTO_COMPLETE_FIELD_THEME}
            >
                <Autocomplete
                    multiple
                    id={'shipmentIdentifiers' + index}
                    key={isEmptyList(identifiers)}
                    disabled={disableField()}
                    onChange={(event, values) => handleOnChangeIdentifier(event, values, index)}
                    disableCloseOnSelect
                    disableListWrap={true}
                    value={selectedIdentifier}
                    options={
                        identifiers.get(selectedDatasource?.id)
                            ? identifiers.get(selectedDatasource?.id)
                            : []
                    }
                    renderTags={(tagValue, getTagProps) => tagValue.join(', ')}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            variant={variant}
                            margin="normal"
                            onBlur={() => isError(selectedIdentifier)}
                            error={errorField.isInvalid}
                            helperText={touched && errorField.message}
                            label="Add Shipment Identifiers"
                        />
                    )}
                />
            </MuiThemeProvider>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        identifiers: state.agreement.identifiers
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getShipmentIdentifiers: (datasourceId) =>
            dispatch(actions.getShipmentIdentifiers(datasourceId))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(IdentifierSearch);
